import ExplorerSvg from './assets/images/svgs/Explorer.svg?react';
// import { ReactComponent as WorkspacesSvg } from './assets/images/svgs/Workspaces.svg';
// import { ReactComponent as StoragesSvg } from './assets/images/svgs/Storages.svg';
// import { ReactComponent as PipelinesSvg } from './assets/images/svgs/Pipelines.svg';
import CollectionSvg from './assets/images/svgs/Collection.svg?react';
import OrderSvg from './assets/images/svgs/Order.svg?react';
import ProviderSvg from './assets/images/svgs/Provider.svg?react';
import { DownloadIcon } from './assets/images/svgs/Icons';

export const Routes = [
    {
        id: 1,
        name: 'explorer',
        label: 'Explorer',
        icon: <ExplorerSvg />,
        tooltip: 'Explorer',
        place: 'right-start',
        path: '/',
        className: 'bottomBorder'
    },
    {
        id: 2,
        name: 'collections',
        label: 'Collections',
        icon: <CollectionSvg />,
        tooltip: 'Collections',
        place: 'right-start',
        path: '/collections',
        className: 'bottomBorder'
    },
    {
        id: 3,
        name: 'orders',
        label: 'Orders',
        icon: <OrderSvg />,
        tooltip: 'Orders',
        place: 'right-start',
        path: '/orders',
    },
    {
        id: 4,
        name: 'downloads',
        label: 'Downloads',
        icon: <DownloadIcon />,
        tooltip: 'Downloads',
        place: 'right-start',
        path: '/downloads',
        className: 'bottomBorder'
    },
    {
        id: 5,
        name: 'providers',
        label: 'Providers',
        icon: <ProviderSvg />,
        tooltip: 'Providers',
        place: 'right-start',
        path: '/providers',
        className: 'bottomBorder'
    },
    // {
    //     id: 6,
    //     name: 'workspaces',
    //     label: 'Workspaces',
    //     icon: <WorkspacesSvg />,
    //     tooltip: 'Workspaces',
    //     place: 'right-start',
    //     path: '/workspaces',
    //     className: 'bottomBorder'
    // },
    // {
    //     id: 7,
    //     name: 'storages',
    //     label: 'Storages',
    //     icon: <StoragesSvg />,
    //     tooltip: 'Storages',
    //     place: 'right-start',
    //     path: '/storages',
    // },
    // {
    //     id: 8,
    //     name: 'pipelines',
    //     label: 'Data Pipelines',
    //     icon: <PipelinesSvg />,
    //     tooltip: 'Data Pipelines',
    //     place: 'right-start',
    //     path: '/pipelines',
    // },
]